import { CellContext } from '@tanstack/react-table';
import { Device } from '@/types/device.types';
import { formatTimezoneShort } from '@/utils/formatters/timezoneFormatter';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const DeviceLastConnectionZoneCell = (info: CellContext<Device, any>) => {
  const tz = info.row.original.lastConnectionTz ?? 'UTC';
  return <span className="text-xs text-gray-600">{formatTimezoneShort(tz)}</span>;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const DeviceLastOperationZoneCell = (info: CellContext<Device, any>) => {
  const tz = info.row.original.lastOperationTz ?? 'UTC';
  return <span className="text-xs text-gray-600">{formatTimezoneShort(tz)}</span>;
};
